/**
 * Parent-facing copy: empty = neutral fact; error = “We couldn’t…”.
 * Keep wording consistent across TopBar, lists, transport, and drawers.
 */

export const UI_MSG = {
  // Postcode / home
  POSTCODE_FORMAT: "Enter a valid UK postcode (for example SW19 5AB).",
  POSTCODE_NOT_FOUND: "We couldn’t find that postcode. Check the letters and numbers, then try again.",
  POSTCODE_INVALID: "Enter a valid UK postcode (for example SW19 5AB).",
  POSTCODE_LOOKUP_UNAVAILABLE:
    "We can’t look up postcodes right now. Try again in a moment, or select a point on the map.",

  // Current location (home page target)
  LOCATION_UNSUPPORTED: "This browser can’t use your current location. Enter a postcode, or select a point on the map.",
  LOCATION_INSECURE:
    "Location only works on a secure page (https or localhost). Enter a postcode, or select a point on the map.",
  LOCATION_DENIED:
    "Location is blocked for this site. Click the lock by the address bar, set Location to Ask or Allow, then try again.",
  LOCATION_UNAVAILABLE:
    "No position came back from this browser. On a Mac: System Settings → Privacy & Security → Location Services → turn it on and allow your browser. Then try again — or enter a postcode / select a point on the map.",
  LOCATION_TIMEOUT:
    "Location was allowed, but no position came back in time. Try again, or enter a postcode / select a point on the map.",

  // Schools list / map
  SCHOOLS_LOAD_FAILED:
    "We couldn’t load schools right now. Refresh the page, or try again in a moment.",
  SCHOOLS_EMPTY_AREA: "No schools to show for this area yet.",

  // Catchment eligibility (home vs schools)
  CATCHMENT_CHECK_FAILED:
    "We couldn’t check catchments for your home yet. School lists may be incomplete — refresh, or try again shortly.",

  // Catchment drawer / map shape
  CATCHMENT_LOAD_FAILED:
    "We couldn’t load this school’s catchment on the map. Try again in a moment.",

  // Transport
  TRANSPORT_NEED_HOME: "Set your home (postcode or map click) to see travel options.",
  TRANSPORT_NONE: "No bus or train options found for this journey from your home.",
  TRANSPORT_LOAD_FAILED:
    "We couldn’t load travel options right now. Please try again.",
  TRANSPORT_UNAVAILABLE:
    "Travel lookup isn’t available right now. Please try again later.",

  // Filters
  FILTER_META_LOAD_FAILED:
    "We couldn’t load some filter options. You can still browse schools — refresh if filters look incomplete.",

  // Drawer data panels
  ADMISSIONS_LOAD_FAILED:
    "We couldn’t load admissions details for this school. Please try again.",
  INSPECTIONS_LOAD_FAILED:
    "We couldn’t load Ofsted / inspection details. Please try again.",
  SUBJECTS_LOAD_FAILED: "We couldn’t load subject details. Please try again.",
  GCSE_LOAD_FAILED: "We couldn’t load GCSE results for this school.",
  ALEVEL_LOAD_FAILED: "We couldn’t load A level results for this school.",
  DESTINATIONS_LOAD_FAILED: "We couldn’t load destinations for this school.",

  // Search / favourites (empty, not errors)
  SEARCH_EMPTY: "No schools match this search. Try a shorter name.",
  FAV_EMPTY_NONE_YET: "No favourites yet — tap the heart on a school.",
  FAV_EMPTY_SECTION: "None of these schools are in your favourites.",

  // Service / map shell
  SERVER_UNREACHABLE:
    "We’re having trouble reaching our servers. Refresh the page, or try again shortly.",
  MAP_TILES_FAILED:
    "The map tiles couldn’t load. Check your connection, then refresh.",
};
